/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vehicleNumber: NonNullable<unknown> }} Vehicle_BreadcrumbInputs */

const fr_vehicle_breadcrumb = /** @type {(inputs: Vehicle_BreadcrumbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Véhicule n°${i?.vehicleNumber}`)
};

const en_vehicle_breadcrumb = /** @type {(inputs: Vehicle_BreadcrumbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vehicle no. ${i?.vehicleNumber}`)
};

/**
* | output |
* | --- |
* | "Vehicle no. {vehicleNumber}" |
*
* @param {Vehicle_BreadcrumbInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_breadcrumb = /** @type {((inputs: Vehicle_BreadcrumbInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_BreadcrumbInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_breadcrumb(inputs)
	return en_vehicle_breadcrumb(inputs)
});